module.exports = {"name":"freewheel","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-05-03","repo":"https://bitbucket.org/npaw/freewheel-adapter-js","libVersion":"6.2.0","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getTitle","getResource","getPosition"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 28
// module chunks = 0